/** Форматирование хода работы: размеры, длительности, скорость. Чистые функции, без обращения к часам. */

const NUMBER = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 })

const BYTES_PER_KB = 1024
const BYTES_PER_MB = BYTES_PER_KB * 1024
const MS_PER_SECOND = 1000
const SECONDS_PER_MINUTE = 60
/** Окно замеров скорости по умолчанию, мс. */
const SPEED_WINDOW_MS = 3000
/** «Дольше обычного»: прошло больше типичного во столько раз и не меньше чем на столько мс. */
const OVERDUE_RATIO = 1.5
const OVERDUE_MARGIN_MS = 1000

export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—'
  if (bytes < BYTES_PER_KB) return `${Math.round(bytes)} Б`
  if (bytes < BYTES_PER_MB) return `${NUMBER.format(bytes / BYTES_PER_KB)} КБ`
  return `${NUMBER.format(bytes / BYTES_PER_MB)} МБ`
}

/** «412 мс», «3,2 с», «1 мин 5 с». */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '—'
  if (ms < MS_PER_SECOND) return `${Math.round(ms)} мс`
  const seconds = ms / MS_PER_SECOND
  if (seconds < SECONDS_PER_MINUTE) return `${NUMBER.format(seconds)} с`
  const whole = Math.floor(seconds)
  return `${Math.floor(whole / SECONDS_PER_MINUTE)} мин ${whole % SECONDS_PER_MINUTE} с`
}

export interface TransferSample {
  /** Момент замера, мс (любые часы, лишь бы одни и те же). */
  at: number
  loaded: number
}

/** Скорость по окну последних замеров, байт/с; `null` — замеров мало или время не прошло. */
export function bytesPerSecond(samples: readonly TransferSample[], windowMs = SPEED_WINDOW_MS): number | null {
  const last = samples.at(-1)
  if (last === undefined) return null
  const recent = samples.filter((sample) => last.at - sample.at <= windowMs)
  const first = recent[0]
  if (first === undefined || last.at <= first.at) return null
  return Math.max(0, (last.loaded - first.loaded) / ((last.at - first.at) / MS_PER_SECOND))
}

/** Оценка оставшегося времени по реальной скорости, секунды; `null` — скорости или размера нет. */
export function remainingSeconds(loaded: number, total: number | null, speed: number | null): number | null {
  if (total === null || speed === null || speed <= 0) return null
  return Math.max(0, (total - loaded) / speed)
}

/** Дольше обычного: прошло заметно больше типичного (в полтора раза и не меньше чем на секунду). */
export function isOverdue(elapsedMs: number, typicalMs: number | null | undefined): boolean {
  return typicalMs != null && elapsedMs > Math.max(typicalMs * OVERDUE_RATIO, typicalMs + OVERDUE_MARGIN_MS)
}
